import React, { useState } from 'react';
import PostcodeSearch from './PostcodeSearch-VIP';
import './InPersonValStepOne.scss';

function InPersonValStepOne({ propertyDetails, handleChange, handleNext }) {
  const [selectedAddress, setSelectedAddress] = useState(
    propertyDetails.address || ''
  );
  const [errors, setErrors] = useState({}); // Object to track errors for each field
  const [valuationType, setValuationType] = useState(null); // Track selected valuation type
  const [area, setArea] = useState(''); // Track the area name


  const validatePostcode = (postcode) => {
    const postcodeRegex = /^[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}$/i;
    return postcodeRegex.test(postcode.trim());
  };

  const handlePostcodeChange = (postcode) => {
    const trimmedPostcode = postcode.trim();
    handleChange({ target: { name: 'postcode', value: trimmedPostcode } });

    if (!validatePostcode(postcode)) {
      setErrors((prevErrors) => ({ ...prevErrors, postcode: true }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, postcode: false }));
    }
  };

  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
    handleChange({ target: { name: 'address', value: address } });
    if (errors.address) {
      setErrors((prevErrors) => ({ ...prevErrors, address: false }));
    }
  };

  const handleValuationSelect = (type) => {
    setValuationType(type);
    handleChange({ target: { name: 'valuationType', value: type } });
  };

  const handleNextClick = () => {
    const newErrors = {};
  
    if (!validatePostcode(propertyDetails.postcode)) {
      newErrors.postcode = true;
    }
  
    if (!selectedAddress) {
      newErrors.address = true;
    }
  
    if (!area) {
      newErrors.area = true; // Ensure the area is valid
    }
  
    if (!valuationType) {
      newErrors.valuationType = true;
    }
  
    setErrors(newErrors);
  
    if (Object.keys(newErrors).length === 0) {
      handleNext();
    }
  };
  

  return (
    <div className="valuation-form-wrapper">
      <div className="logo-container">
        <img 
          src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2FChrist_Stonock_logo_wide.png?alt=media&token=c45b9b95-a1c5-4c7a-b518-d7ba3628d050" 
          alt="Chris Stonock Your Move Logo" 
          className="header-logo" 
        />
      </div>
      <div className="step-one-container">
        <h1 className="brand-title">Free Property Valuation</h1>
        <p className="step-one-description">
          How much is your home worth? Book a <span style={{ fontWeight: 'bold', color: '#1e2140' }}>FREE</span>, at-property valuation with our local experts.
        </p>

        <div className="step-one-form-row">
          <PostcodeSearch
            onPostcodeChange={handlePostcodeChange}
            onSelectAddress={handleAddressSelect}
            postcode={propertyDetails.postcode}
            selectedAddress={selectedAddress}
            errors={errors}
            setArea={(newArea) => {
              setArea(newArea); // Update the local area state
              handleChange({ target: { name: 'area', value: newArea } }); // Add area to propertyDetails
            }}
          />
        </div>

        {selectedAddress && <hr className="divider-line" />}

        {selectedAddress && (
          <div className="valuation-type-selection">
            <p className="valuation-question">What type of valuation would you like?</p>
            <div className="valuation-buttons">
              {['Sales', 'Rental', 'Both'].map((type) => (
                <button
                  type="button"
                  key={type}
                  className={`valuation-button ${
                    valuationType === type ? 'active' : ''
                  } ${errors.valuationType ? 'error-border' : ''}`}
                  onClick={() => handleValuationSelect(type)}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="step-one-form-row next-button-row">
          <button
            type="button"
            onClick={handleNextClick}
            className={`step-one-next-button ${!valuationType ? 'disabled-button' : ''}`}
            disabled={!valuationType}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default InPersonValStepOne;
